import orderStatuses from '@/util/orderStatuses'

export default {
  orderStatusOptions () {
    return Object.keys(orderStatuses).map(key => {
      return {
        label: orderStatuses[key],
        value: key,
      }
    })
  },
}
